export const COMPANY_PHONE = "0985768181";
